import * as i0 from '@angular/core';
import { Component, Input, HostBinding, NgModule } from '@angular/core';

/**
 * Represents a check that can be used as part of checkboxes or checkmarks.
 */
class CheckComponent {
    constructor() {
        /**
         * Check's width in pixels.
         */
        this.width = 16;
        /**
         * Check's height in pixels.
         */
        this.height = 12;
    }
    get display() {
        return 'block';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: CheckComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.1.4", type: CheckComponent, selector: "hy-check", inputs: { width: "width", height: "height" }, host: { properties: { "style.display": "this.display" } }, ngImport: i0, template: `
    <svg
      aria-label="check"
      [attr.width]="width"
      [attr.height]="height"
      role="img"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6663 1L5.49967 10.1667L1.33301 6"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: CheckComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hy-check',
                    template: `
    <svg
      aria-label="check"
      [attr.width]="width"
      [attr.height]="height"
      role="img"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6663 1L5.49967 10.1667L1.33301 6"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
                }]
        }], propDecorators: { width: [{
                type: Input
            }], height: [{
                type: Input
            }], display: [{
                type: HostBinding,
                args: ['style.display']
            }] } });
const DIRECTIVES = [CheckComponent];
class CheckModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: CheckModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.1.4", ngImport: i0, type: CheckModule, declarations: [CheckComponent], exports: [CheckComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: CheckModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: CheckModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DIRECTIVES],
                    exports: [DIRECTIVES],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CheckComponent, CheckModule };
